import { noop } from "lodash";
import { PromoCTA } from "../types";

export const defaultCTA: PromoCTA = {
  CTALabel: "",
  onCTAPress: noop,
  CTAShow: false
};
